module.exports = __webpack_public_path__ + "img/blue-bg.dc93c670.png";